import { render } from "./DietGroupPage.vue?vue&type=template&id=6a8c58dd"
import script from "./DietGroupPage.vue?vue&type=script&lang=js"
export * from "./DietGroupPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/farena/workspace/smt/smt_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__